<ng-container *appSheetsAppContext>
<app-sheets-rail-controls #controls />

<div class="sheets-shell">
  <app-collapsible-rail-shell
    class="sheets-rail"
    [app]="app"
    [actionsTemplate]="controls.actionsTemplate()"
    [temporaryParked]="railFolded()"
    (temporaryUnparked)="fullWindow.reopenRail()"
  >
    <stch-side-bar-teams
      *stchSpaceRerender
      [template]="sidebarTemplate"
      [splitViewKey]="SidebarSplitViewKey.sheets"
    />
  </app-collapsible-rail-shell>

  <div class="sheets-rest">
    <!-- Columns 2 and 3. Expanding a workbook replaces BOTH with the editor,
         which is what the client meant by "expands across columns 2 and 3";
         the list waits beside it, folded to its edge tab (SBUX-1145). The rail
         stays put, unless the workbook opened full-window: then the rail parks
         and the Dynamic Panel collapses too. -->
    @if (expanded) {
      <!-- SBUX-1145: the list folds to its edge tab beside the workbook and opens beside it on a click (Wook,
           2026-10-27: "Yes, add a list toggle"); a workbook clicked there opens in the editor. Only widths change, so
           the editor is never rebuilt. -->
      <app-split-view
        side="left"
        key="sheetsEditorList"
        [collapsedSize]="25"
        [shadow]="true"
        [magneticSize]="300"
        [withIcon]="true"
        [iconTop]="38"
        [temporaryCollapsed]="!editorListOpen()"
        (temporaryOpened)="editorListOpen.set(true)"
      >
        <app-sheets-list-container
          split-left-pane
          *stchSpaceRerender
          class="list shadow-lg"
          [inEditor]="true"
          [minimized]="editorListMinimized()"
        />
        <div class="expanded shadow-lg" split-right-pane>
          <!-- SBUX-1036: the workbook's detail view, stretched, with its header and tabs; the editor is its Sheets tab.
               Lazy: the workbook chunk is only fetched once one is actually opened. -->
          <app-sheets-expanded-view (closed)="close()">
            <router-outlet />
          </app-sheets-expanded-view>
        </div>
      </app-split-view>
    } @else {
      <app-split-view
        side="left"
        key="sheetsList"
        [collapsedSize]="25"
        [shadow]="true"
        [magneticSize]="300"
        [withIcon]="true"
        [iconTop]="38"
      >
        <app-sheets-list-container
          split-left-pane
          *stchSpaceRerender
          class="list shadow-lg"
        />

        <div class="full-form shadow-lg" split-right-pane>
          <app-sheets-main-view *stchSpaceRerender />
        </div>
      </app-split-view>
    }
  </div>

  <ng-template #sidebarTemplate let-team="team">
    <app-sheets-side-bar [team]="team"/>
  </ng-template>
</div>
</ng-container>
